<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >{{ room.title }}
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <room-info-form v-if="room.id" :room="room" ref="form"></room-info-form>
      <v-row class="pr-6 pb-6 mt-n7" no-gutters>
        <v-spacer></v-spacer>
        <v-btn
          class="px-6"
          depressed
          color="primary"
          :loading="loading"
          @click="save"
          >Lưu</v-btn
        >
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import RoomInfoForm from '@/components/basic/form/RoomForm.vue'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    RoomInfoForm
  },
  props: {
    state: Boolean,
    room: { type: Object, default: () => {} }
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters('rooms', ['rooms']),
    ...mapState('app', ['roles', 'department']),
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('rooms', ['updateRoom', 'fetchRooms']),
    async save() {
      this.loading = true
      const data = this.$refs.form.getData()
      await this.updateRoom({ id: this.room.id, ...data })
      await this.fetchRooms({ department: this.department.id })
      this.loading = false
      this.dialog = false
    },
    cancel() {
      this.dialog = false
      this.$refs.form.resetDefault()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
